module.exports = __webpack_public_path__ + "img/5.b8f7f42a.png";